module.exports = __webpack_public_path__ + "media/b-2.2237dd11.mp3";